import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { INDUSTRIAL_RESOURCE_MULTIPLIER } from 'helpers/i18n'

import styles from './BattlesButton.scss'

const BattlesButton = (props) => {
    const className = classNames(styles.base, {
        [styles.base__primary]: props.primary,
    })

    const glow = props.primary ? (
        <span className={styles.glow}></span>
    ) : null

    const multiplier = props.industrialResourceMultiplier > 1 ? (
        <span className={styles.multiplier}>{INDUSTRIAL_RESOURCE_MULTIPLIER(props.industrialResourceMultiplier)}</span>
    ) : null

    return (
        <button
            className={className}
            onClick={props.handleClick}
            onMouseEnter={props.handleHover}
            data-tip data-for={props.tooltipId}
        >
            {glow}
            <span className={classNames(styles.caption, { [styles.caption__glow]: !!multiplier })}>
                {props.caption}
                {multiplier}
                <span className={styles.captionGradient}>
                    {props.caption}
                    {multiplier}
                </span>
            </span>
        </button>
    )
}

BattlesButton.propTypes = {
    caption: PropTypes.node.isRequired,
    handleClick: PropTypes.func.isRequired,
    handleHover: PropTypes.func.isRequired,
    primary: PropTypes.bool,
    tooltipId: PropTypes.string,
    industrialResourceMultiplier: PropTypes.number,
}

export default BattlesButton



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/BattlesButton/BattlesButton.jsx